import { render, staticRenderFns } from "./PrivacyMobile.vue?vue&type=template&id=3e57ef8a&scoped=true"
import script from "./PrivacyMobile.vue?vue&type=script&lang=ts"
export * from "./PrivacyMobile.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e57ef8a",
  null
  
)

export default component.exports